document.querySelectorAll('.pdp-ugc').forEach(function (section) {
  var playBtn = section.querySelector('[data-pdp-ugc-play]');
  var lightbox = section.querySelector('[data-pdp-ugc-lightbox]');
  var closeBtn = section.querySelector('[data-pdp-ugc-close]');
  var media = section.querySelector('[data-pdp-ugc-media]');

  if (!playBtn || !lightbox) return;

  function openLightbox() {
    lightbox.hidden = false;
    var video = media.querySelector('video');
    if (video) video.play();
  }

  function closeLightbox() {
    lightbox.hidden = true;
    var video = media.querySelector('video');
    var iframe = media.querySelector('iframe');
    if (video) video.pause();
    if (iframe) iframe.src = iframe.src;
  }

  playBtn.addEventListener('click', openLightbox);
  if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
  lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox) closeLightbox();
  });
});
